import script from "./ProductsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsHome.vue?vue&type=script&setup=true&lang=js"

import "./ProductsHome.vue?vue&type=style&index=0&id=c7fe8ce8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7fe8ce8"]])

export default __exports__